import {
  ConfigLoader,
  DefaultConfigLoader,
  HttpClientLoaderTranslation,
  OAuthInterceptor,
  RestService,
  SettingsService,
  W3hostnameInterceptor,
} from '@infodata-group/inf-commons';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import {
  EnvironmentProviders,
  ImportProvidersSource,
  Provider,
} from '@angular/core';
import {
  CustomRestService,
  CustomServerSettingsService,
} from '@monorepo-projects/alwayson-shared';

export const commonsProvidersFrom: ImportProvidersSource[] = [
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpClientLoaderTranslation,
      deps: [HttpClient],
    },
  }),
  GoogleMapsModule,
  EditorModule,
];

export const commonsProviders: Array<Provider | EnvironmentProviders> = [
  { provide: ConfigLoader, useClass: DefaultConfigLoader },
  { provide: SettingsService, useClass: CustomServerSettingsService },
  { provide: RestService, useClass: CustomRestService },
  { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.js' }, // providing js for Tinymce
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: W3hostnameInterceptor,
    multi: true,
  },
];
